/**
 * Top sports content types.
 *
 * @class TopSportsTypes
 * @name types
 * @memberof Mojito.Modules.TopSports
 */
export default class TopSportsTypes {}

/**
 * Content type enum determining which events to display.
 *
 * @readonly
 * @enum {string}
 * @memberof Mojito.Modules.TopSports.types
 */
TopSportsTypes.CONTENT_TYPE = {
    /** Display only live (in-play) events. */
    LIVE: 'live',
    /** Display only future (pre-play) events. */
    FUTURE: 'future',
    /** Display both live and future events. */
    LIVE_AND_FUTURE: 'live-and-future',
};
